const API_KEY = 'ee94c28793e897f5ab3e42b6b141640f';
const BASE_URL = 'https://api.themoviedb.org/3';
const TRENDING_URL = `${BASE_URL}/trending/movie/`;
const SEARCH_URL = `${BASE_URL}/search/movie`;
const ID_URL = `${BASE_URL}/movie/`;
const DISCOVER_URL = `${BASE_URL}/discover/movie`;

export { API_KEY, BASE_URL, TRENDING_URL, SEARCH_URL, ID_URL, DISCOVER_URL };
